import React from "react";

import cx from "classnames";

import { Tooltip } from "~/ui";
import type { TooltipProps } from "~/ui";
import Button, { type ButtonProps } from "~/ui/button";

import styles from "./SharedComponents.module.css";

export const ControlsGroup = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{ className?: string }>>(
	({ children, className, ...props }, ref) => {
		return (
			<div ref={ref} className={cx(styles.controlsGroup, className)} {...props}>
				{children}
			</div>
		);
	},
);

ControlsGroup.displayName = "ControlsGroup";

export const ControlGroupIconButton = React.forwardRef<HTMLButtonElement, Omit<ButtonProps, "variant">>(
	({ children, className, ...props }, ref) => {
		return (
			<Button ref={ref} className={cx(styles.controlsGroupIconButton, className)} variant="tertiary" {...props}>
				{children}
			</Button>
		);
	},
);

ControlGroupIconButton.displayName = "ControlGroupIconButton";

export const ControlGroupButtonTooltip = React.forwardRef<Element, Omit<TooltipProps, "placement" | "offset">>(
	({ children, ...props }, ref) => {
		return (
			<Tooltip ref={ref} placement="top" offset={[0, 12]} {...props}>
				{children}
			</Tooltip>
		);
	},
);

ControlGroupButtonTooltip.displayName = "ControlGroupButtonTooltip";

export const ControlsGroupItem = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{ className?: string }>>(
	({ children, className, ...props }, ref) => {
		return (
			<div ref={ref} className={cx(styles.controlsGroupItem, className)} {...props}>
				{children}
			</div>
		);
	},
);

ControlsGroupItem.displayName = "ControlsGroupItem";

export const ControlButton = React.forwardRef<
	HTMLButtonElement,
	Omit<ButtonProps, "variant"> & { innerClassName?: string }
>(({ children, className, innerClassName, ...props }, ref) => {
	return (
		<Button ref={ref} className={cx(styles.controlButton, className)} variant="secondary" {...props}>
			<div className={cx(styles.controlButtonInner, innerClassName)}>{children}</div>
		</Button>
	);
});

ControlButton.displayName = "ControlButton";
